import React from 'react'
import styles from './ContainerRow.module.css'

export function ContainerRow ({ children }) {
  return <div className={styles.root}>{children}</div>
}
